import { ErrorService, ParseService } from '../services';
import { ShopOrder, CommercialUpgradeQuote } from '../models';
import { BaseModelService } from './base/base-modelservice';

export class ShopOrderService extends BaseModelService<ShopOrder> {

    constructor(errorService: ErrorService, parseService: ParseService) {
        super(errorService, parseService, ShopOrder);
    }

    public CreateOrder(productId: string, state?: string): Promise<string> {
        return this.runCloudMethod('ShopOrderCloud.createOrder', [...Array.from(arguments)]);
    }

    public QuoteCommercialUpgrade(): Promise<CommercialUpgradeQuote> {
        return this.runCloudMethod('ShopOrderCloud.quoteCommercialUpgrade', []);
    }

    public CreateCommercialUpgrade(quoteId: string, state: string): Promise<string> {
        return this.runCloudMethod('ShopOrderCloud.createCommercialUpgrade', [quoteId, state]);
    }

    public ConfirmOrder(paypalPaymentId: string, PaypalPayerId): Promise<string> {
        return this.runCloudMethod('ShopOrderCloud.confirmOrder', [...Array.from(arguments)]);
    }
}
